import { render } from "./AdministerCollection.vue?vue&type=template&id=68974e15"
import script from "./AdministerCollection.vue?vue&type=script&lang=js"
export * from "./AdministerCollection.vue?vue&type=script&lang=js"

import "./AdministerCollection.vue?vue&type=style&index=0&id=68974e15&lang=postcss"

import exportComponent from "/var/vhosts/unrisd-frontend/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__